import * as React from "react";

function SvgChamber(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M31.167 0H2.833C.708 0 0 .708 0 2.812V33.58c0 .232.191.421.425.421h4.817c.233 0 .425-.19.425-.42V7.348c0-.925.775-1.682 1.732-1.682h19.203c.956 0 1.731.757 1.731 1.682v26.23c0 .232.192.421.425.421h4.817c.234 0 .425-.19.425-.42V2.811C34 .708 33.292 0 31.167 0z"
        fill="#fff"
      />
      <path
        d="M8.5 17.708c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708v-1.417zM8.5 21.958c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708v-1.417zM8.5 26.208c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708v-1.417zM8.5 30.458c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708v-1.417zM8.5 13.458c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708v-1.417zM8.5 9.208c0-.39.317-.708.708-.708h15.584c.39 0 .708.317.708.708v1.417a.708.708 0 01-.708.708H9.208a.708.708 0 01-.708-.708V9.208z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgChamber;
